import React from "react";
import { Subscribe } from "unstated";

export default (containerClasses) => (Component) => (props) =>
  (
    <Subscribe to={Object.values(containerClasses)}>
      {(...containers) => (
        <Component
          {...containers.reduce((acc, container, i) => {
            const name = Object.keys(containerClasses)[i];
            acc[name.charAt(0).toLowerCase() + name.slice(1)] = container;
            return acc;
          }, {})}
          {...props}
        />
      )}
    </Subscribe>
  );
